import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { GeoJSON } from "react-leaflet";
import { onParkingSpotClick } from "./../../actions/parkingSpots";
import { currentStateForSpot } from "./../../utils";
import ParkingSpotMarkerLayer from "./ParkingSpotMarkerLayer";
import styles from "./../../styles/parkingSpots";
import { SHOW_PARKING_SPOTS_ZOOM_LEVEL } from "../../constants";
import { removeItemFromArray, appendItemToArray } from "../../reducers/helper";

class ParkingSpots extends Component {
	constructor(props) {
		super(props);
		this.onEachFeature = this.onEachFeature.bind(this);
		this.parkingSpotStyle = this.parkingSpotStyle.bind(this);
	}

	parkingSpotStyle(feature) {
		const { spotid } = feature.properties;
		const { selectedSpot } = this.props;
		const currentState = currentStateForSpot(spotid);

		const { status } = currentState;
		const isOpenSpot = status === "OPEN";

		const baseStyle = {
			fillColor: "#ffffff",
			color: "#d0d5d8",
			weight: 1,
			fillOpacity: 1,
		};

		if (spotid === selectedSpot) {
			if (status === "OPEN") {
				// Selected and available
				// return styles.selectedAvailableSpot;
				return {
					// Selected
					...baseStyle,
					color: "#1f2b3f",
				};
			} else {
				// Selected and not available
				// return styles.selectedUnavailableSpot;
				return {
					...baseStyle,
					color: "#1f2b3f",
					fillColor: "#eceeef",
				};
			}
		}
		if (isOpenSpot) {
			// Not selected and open
			// return styles.availableSpot;
			return {
				...baseStyle,
			};
		}
		// return styles.reservedSpot;
		return {
			// Not selected and not available
			...baseStyle,
			fillColor: "#eceeef",
		};
	}

	onEachFeature(feature, layer) {
		layer.on({
			click: () => {
				this.props.onParkingSpotClick(feature.properties);
			},
		});
	}

	render() {
		const { data, zoomLevel, showParkingSpotMarker, showParkingSpotMarkerLabel, selectedSpot } = this.props;
		const showMarker = showParkingSpotMarker && zoomLevel >= SHOW_PARKING_SPOTS_ZOOM_LEVEL;
		const isSelectedSpotPresent = !!selectedSpot;
		if (isSelectedSpotPresent) {
			const index = data.features.findIndex(feature => feature.properties.spotid === selectedSpot);
			if (index >= 0) {
				const features = removeItemFromArray(data.features, index);
				const newFeatures = appendItemToArray(features, data.features[index]);
				data.features = newFeatures;
			}
		}
		return (
			<div>
				<g>
					<GeoJSON
						key={Math.random()}
						data={data}
						onEachFeature={this.onEachFeature}
						style={this.parkingSpotStyle}
						bubblingMouseEvents={false}
					/>
				</g>
				<g>{showMarker && <ParkingSpotMarkerLayer features={data.features} />}</g>
			</div>
		);
	}
}

const mapStateToProps = state => {
	const { list: parkingSpotsList, selectedSpot, showParkingSpotMarker } = state.parkingSpots;
	return {
		parkingSpotsList,
		selectedSpot,
		showParkingSpotMarker,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ onParkingSpotClick }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ParkingSpots);



// WEBPACK FOOTER //
// ./src/containers/MapLayers/ParkingSpots.js